import React from 'react';
import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { CHECKBOX_NEW_ICON } from '@Images';

const CheckBoxWrapper = styled.div<{
  checked: boolean;
  $broderBorder: boolean;
  $showDisclaimer?: boolean;
  width: number;
  height: number;
  $checkboxTextPaddingTop?: number;
  $checkboxTextMarginTop?: number;
  $checkboxTextFontSize?: number;
  $checkboxTextLineHeight?: number;
}>`
  display: flex;
  align-items: ${({ $showDisclaimer }): string => ($showDisclaimer ? 'flex-start' : 'center')};
  margin-top: ${({ $checkboxTextMarginTop }): string =>
    `${$checkboxTextMarginTop ? $checkboxTextMarginTop : 0}px`};
  span {
    color: ${COLORS.textGrey};
    font-size: ${({ $checkboxTextFontSize }): string =>
      `${$checkboxTextFontSize ? $checkboxTextFontSize : 14}px`};
    padding-top: ${({ $checkboxTextPaddingTop }): string =>
      `${$checkboxTextPaddingTop ? $checkboxTextPaddingTop : 0}px`};
    line-height: ${({ $checkboxTextLineHeight }): string =>
      `${$checkboxTextLineHeight ? $checkboxTextLineHeight : 14}px`};
  }
  input {
    -webkit-appearance: none;
    width: ${(p) => p.width}px;
    height: ${(p) => p.height}px;
    border-radius: 4px;
    border: ${(p) => (p.$broderBorder ? '2px solid #333' : '1.5px solid #494948')} !important;
    margin-right: 10px;
    display: ${(p) => (p.checked ? 'none' : 'content')};
    cursor: pointer;
  }
  img {
    margin-right: 10px;
    width: ${(p) => p.width}px;
    height: ${(p) => p.height}px;
    display: ${(p) => (p.checked ? 'content' : 'none')};
    cursor: pointer;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  .error-msg-checkbox {
    margin-top: 10px;
    font-size: 11px;
    color: ${COLORS.red};
  }
`;
type CHECKBOX_PROPS = {
  input?: {
    name: string;
    value: string;
  };
  checked: boolean;
  meta?: {
    form: string;
    error: string;
    touched: string;
  };
  checkboxContent: any;
  handleChange: any;
  customImage?: any;
  broderBorder?: boolean;
  showDisclaimer?: boolean;
  showError?: boolean;
  errFromParent?: any;
  invertedBehavior?: boolean;
  width?: number;
  height?: number;
  checkboxTextPaddingTop?: number;
  checkboxTextFontSize?: number;
  checkboxTextLineHeight?: number;
  checkboxTextMarginTop?: number;
};

const CheckboxField: React.FC<CHECKBOX_PROPS> = (props) => {
  const {
    input,
    checked = false,
    checkboxContent,
    handleChange,
    broderBorder = false,
    showDisclaimer = false,
    invertedBehavior = false,
    width = 20,
    height = 20,
    showError,
    meta,
    errFromParent,
    checkboxTextPaddingTop,
    checkboxTextFontSize,
    checkboxTextLineHeight,
    checkboxTextMarginTop
  } = props;

  return (
    <Wrapper>
      <CheckBoxWrapper
        onClick={() => {
          handleChange(false);
        }}
        checked={invertedBehavior ? !checked : checked}
        $broderBorder={broderBorder}
        $showDisclaimer={showDisclaimer}
        width={width}
        height={height}
        $checkboxTextPaddingTop={checkboxTextPaddingTop}
        $checkboxTextFontSize={checkboxTextFontSize}
        $checkboxTextLineHeight={checkboxTextLineHeight}
        $checkboxTextMarginTop={checkboxTextMarginTop}
      >
        <div>
          <img src={props?.customImage ? props.customImage : CHECKBOX_NEW_ICON} alt="checkbox" />
          <input type="checkbox" {...input} checked={checked} />
        </div>
        <span>{checkboxContent}</span>
      </CheckBoxWrapper>
      {((showError !== false && meta?.touched && meta?.error) || errFromParent) && (
        <div className="error-msg-checkbox"> {meta?.error || errFromParent} </div>
      )}
    </Wrapper>
  );
};

export default CheckboxField;
